import { ReconciliationItemStatus } from '~/swagger/accounting/Api';
import type { ReconciliationSummaryMetricDto } from '~/swagger/accounting/Api';

export const emptyReconciliationSummaryMetric = (): ReconciliationSummaryMetricDto => ({
  count: 0,
  inflowAmount: 0,
  outflowAmount: 0,
  grossAmount: 0,
  netAmount: 0,
});

export const reconciliationSummaryMetric = (metric: ReconciliationSummaryMetricDto | undefined): ReconciliationSummaryMetricDto =>
  metric ?? emptyReconciliationSummaryMetric();

export const DEFAULT_RECONCILIATION_WORK_QUEUE_STATUSES: ReconciliationItemStatus[] = [
  ReconciliationItemStatus.Open,
  ReconciliationItemStatus.NeedsReview,
];
